<template>
  <div v-if="this.links">
    <v-layout row wrap pb-4 :class="paddingTop">
      <v-flex xs12 sm12 md6 :class="paddingRightCarousel">
        <v-carousel
          v-if="links.left"
          height="220px" 
          interval="15000" 
          style="box-shadow: none;" 
          class="carousel-links"
          :hide-controls="links.left.length < 2"
          :hide-delimiters="links.left.length < 2"
        >
          <v-carousel-item
            v-for="(item,i) in links.left"
            :key="i"
            :src="item.image"
            contain
            @click="goToLink(item)"
            class="hover"
          ></v-carousel-item>
        </v-carousel>
      </v-flex>
      <v-flex xs12 md6 :class="paddingLeftCarousel">
        <v-carousel 
          v-if="links.right"
          height="220px" 
          interval="18000" 
          style="box-shadow: none;" 
          class="carousel-links"
          :hide-controls="links.right.length < 2"
          :hide-delimiters="links.right.length < 2"
        >
          <v-carousel-item
            v-for="(item,i) in links.right"
            :key="i"
            contain
            :src="item.image"
            @click="goToLink(item)"
            class="hover"
          ></v-carousel-item>
        </v-carousel>
      </v-flex>
    </v-layout>
  </div>
  <div v-else></div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  beforeMount() {
    if (!this.links.length) {
      let view_as = localStorage.getItem("view_as");
      this.fetchLinks(view_as);
    }
  },
  methods: {
    ...mapActions("links",["fetchLinks"]),
    goToLink(link) {
      if (link.is_blank == true) window.open(link.url, "_blank");
      else window.open(link.url, "_self");
    },
  },
  computed: {
    ...mapState("links", ["links"]),
    paddingTop() {
      if (this.$vuetify.breakpoint.smAndDown) {
        return 'pt-0';
      } else {
        return 'pt-4';
      }
    },
    paddingLeftCarousel() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        return 'pl-4';
      } else {
        return 'pl-0';
      }
    },
    paddingRightCarousel() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        return 'pr-4';
      } else {
        return 'pr-0';
      }
    }
  }
}
</script>

<style>
.carousel-links
  > div.v-carousel__controls
  > div
  > button.v-btn.v-btn--active.v-btn--icon.v-btn--small.theme--dark.v-carousel__controls__item {
  color: #638d37;
}

.carousel_links > div.v-carousel__controls > div > button {
  height: 17px;
  width: 17px;
}
</style>